// Utilitaires purs (sans dépendance d'environnement).

const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

export function esc(value: string | null | undefined): string {
  if (value == null) return '';
  return String(value).replace(/[&<>"']/g, (c) => HTML_ESCAPES[c]);
}

/** N'accepte que http(s), mailto: et tel:. Tout le reste (javascript:, data:…) est rejeté. */
export function safeUrl(value: string | null | undefined): string | null {
  if (!value) return null;
  const v = String(value).trim();
  if (/^(https?:\/\/|mailto:|tel:)/i.test(v)) return v;
  return null;
}

/** Couleur CSS hexadécimale uniquement (#rgb ou #rrggbb) — évite toute injection dans les attributs style. */
export function safeColor(value: string | null | undefined, fallback: string): string {
  if (value && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(value.trim())) return value.trim();
  return fallback;
}

/** Pile de polices : lettres, chiffres, espaces, virgules, tirets, apostrophes. */
export function safeFont(value: string | null | undefined, fallback: string): string {
  if (value && /^[\w\s,'"-]+$/.test(value)) return value.replace(/"/g, "'");
  return fallback;
}

/** "06 12 34 56 78" -> "tel:+33612345678" (numéros français), sinon chiffres bruts. */
export function telHref(phone: string): string {
  let digits = phone.replace(/[^\d+]/g, '');
  if (digits.startsWith('00')) digits = '+' + digits.slice(2);
  if (/^0\d{9}$/.test(digits)) digits = '+33' + digits.slice(1);
  return 'tel:' + digits;
}

export function domainOf(email: string): string {
  return email.split('@')[1]?.toLowerCase().trim() ?? '';
}

export function lower(s: string): string {
  return s.toLowerCase().trim();
}

/** Hash court et déterministe (djb2) — sert à versionner les URL d'images. Pas cryptographique. */
export function shortHash(input: string): string {
  let h = 5381;
  for (let i = 0; i < input.length; i++) h = ((h << 5) + h + input.charCodeAt(i)) | 0;
  return (h >>> 0).toString(36);
}

/** Hash court déterministe sur 8 caractères hexadécimaux (FNV-1a 32 bits). Pas cryptographique. */
export function hash8(input: string): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < input.length; i++) {
    h ^= input.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return (h >>> 0).toString(16).padStart(8, '0');
}

export function withQuery(url: string, params: Record<string, string>): string {
  const q = Object.entries(params)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return url + (url.includes('?') ? '&' : '?') + q;
}
